var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-button', {
    class: _vm.className,
    style: _vm.style,
    attrs: {
      "variant": _vm.variant,
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.isLoading ? _c('b-spinner', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }